import { IncomingMessage } from 'http'

/**
 * Get the awaze client from request headers
 * @param req - The incoming request object
 * @returns The x-awaze-client header value or null if not present
 *
 * @example
 * // In API routes
 * import { NextApiRequest, NextApiResponse } from 'next'
 * import { getAwazeClient } from '../../utils/headers'
 *
 * export default function handler(req: NextApiRequest, res: NextApiResponse) {
 *   const client = getAwazeClient(req)
 *   console.log('Client:', client) // 'guest-app' or null
 * }
 *
 * @example
 * // In getServerSideProps or getInitialProps
 * import { GetServerSideProps } from 'next'
 * import { getAwazeClient } from '../utils/headers'
 *
 * export const getServerSideProps: GetServerSideProps = async ({ req }) => {
 *   const client = getAwazeClient(req)
 *   return { props: { client } }
 * }
 */
export const getAwazeClient = (req?: IncomingMessage): string | null => {
  if (!req?.headers) return null

  const clientHeader = req.headers['x-awaze-client']
  return Array.isArray(clientHeader) ? clientHeader[0] : clientHeader || null
}

/**
 * Check if the current request is from a guest app
 * @param req - The incoming request object
 * @returns true if this is a guest app request
 */
export const isGuestApp = (req?: IncomingMessage): boolean => {
  const client = getAwazeClient(req)
  return client === 'guest-app'
}
